import { colors } from '../../constants';
import shape from '../../shape';
const MuiChip = {
  root: {
    fontWeight: 'bold',
    borderRadius: shape.borderRadius,
    backgroundColor: colors.secondary.light,
    color: colors.primary.contrastText
  },
  colorPrimary: {
    backgroundColor: colors.secondary.main
  },
  colorSecondary: {
    backgroundColor: colors.background.chatelle
  },
  outlinedPrimary: {
    color: colors.secondary.main,
    borderColor: 'currentColor',
    borderWidth: 2
  },
  outlinedSecondary: {
    color: colors.background.chatelle,
    borderColor: 'currentColor',
    borderWidth: 2
  },
  outlined: {
    color: colors.secondary.light,
    borderColor: 'currentColor',
    borderWidth: 2
  }
};
export default MuiChip;